<section class="clients-page">
  <header class="clients-toolbar">
    <div>
      <h1>Клиенты</h1>
      <span>Список клиентов, подписки на команды и ответственные менеджеры.</span>
    </div>
  </header>

  <div class="message success" *ngIf="successMessage">{{ successMessage }}</div>
  <div class="message error" *ngIf="errorMessage">{{ errorMessage }}</div>

  <section class="clients-panel">
    <div class="panel-tools">
      <div class="status-tabs" aria-label="Фильтр по статусу">
        <button type="button" [class.active]="filters.status === ''" (click)="setStatusFilter('')">Все</button>
        <button type="button" [class.active]="filters.status === 'active'" (click)="setStatusFilter('active')">Активные</button>
        <button type="button" [class.active]="filters.status === 'inactive'" (click)="setStatusFilter('inactive')">Не активные</button>
      </div>

      <label class="search-box">
        <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg>
        <input type="search" placeholder="Поиск клиентов..." [(ngModel)]="filters.search" (ngModelChange)="queueSearch()">
      </label>

      <a class="action-button panel-add-button" routerLink="/dashboard/clients/new">
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14"/><path d="M5 12h14"/></svg>
        <span>Добавить</span>
      </a>
    </div>

    <div class="table-wrap" *ngIf="clients.length > 0; else emptyState">
      <table class="clients-table">
        <thead>
          <tr>
            <th><button type="button" (click)="setSort('client')" [attr.aria-sort]="sortState('client')">Клиент</button></th>
            <th><button type="button" (click)="setSort('subscription')" [attr.aria-sort]="sortState('subscription')">Подписка</button></th>
            <th><button type="button" (click)="setSort('orders')" [attr.aria-sort]="sortState('orders')">Заказы</button></th>
            <th><button type="button" (click)="setSort('total')" [attr.aria-sort]="sortState('total')">Общая сумма</button></th>
            <th><button type="button" (click)="setSort('status')" [attr.aria-sort]="sortState('status')">Статус</button></th>
            <th><button type="button" (click)="setSort('owner')" [attr.aria-sort]="sortState('owner')">Ответственный</button></th>
          </tr>
        </thead>
        <tbody>
          <tr class="client-row" *ngFor="let client of sortedClients; trackBy: trackById" [routerLink]="['/dashboard/clients', getClientRoute(client)]">
            <td>
              <div class="client-cell">
                <span [class.inactive]="client.status === 'inactive'">{{ (client.firstName || '').charAt(0) }}{{ (client.lastName || '').charAt(0) }}</span>
                <div>
                  <strong>{{ getClientName(client) }}</strong>
                </div>
              </div>
            </td>
            <td>
              <div class="chips compact" *ngIf="client.teams.length > 0; else noClientTeams">
                <span class="chip" *ngFor="let team of client.teams.slice(0, 2); trackBy: trackById">{{ team.name }}</span>
                <span class="chip muted-chip" *ngIf="client.teams.length > 2">+{{ client.teams.length - 2 }}</span>
              </div>
              <ng-template #noClientTeams><span class="muted">Нет подписки</span></ng-template>
            </td>
            <td><strong>{{ client.ordersTotal }}</strong></td>
            <td><strong>{{ formatMoney(client.totalPaidAmount) }}</strong></td>
            <td>
              <span class="status-pill" [class.active]="client.status === 'active'">
                {{ client.status === 'active' ? 'Активен' : 'Не активен' }}
              </span>
            </td>
            <td>{{ getOwnerName(client) }}</td>
          </tr>
        </tbody>
      </table>

      <div class="client-cards">
        <article class="client-card" *ngFor="let client of sortedClients; trackBy: trackById" [routerLink]="['/dashboard/clients', getClientRoute(client)]">
          <header>
            <div class="client-cell">
              <span [class.inactive]="client.status === 'inactive'">{{ (client.firstName || '').charAt(0) }}{{ (client.lastName || '').charAt(0) }}</span>
              <div>
                <strong>{{ getClientName(client) }}</strong>
              </div>
            </div>
            <span class="status-pill" [class.active]="client.status === 'active'">
              {{ client.status === 'active' ? 'Активен' : 'Не активен' }}
            </span>
          </header>
          <p>Подписка: <strong>{{ getSubscriptionText(client) }}</strong></p>
          <p>Заказы: <strong>{{ client.ordersTotal }}</strong></p>
          <p>Общая сумма: <strong>{{ formatMoney(client.totalPaidAmount) }}</strong></p>
          <p>Ответственный: <strong>{{ getOwnerName(client) }}</strong></p>
        </article>
      </div>
    </div>

    <ng-template #emptyState>
      <div class="empty-state">
        <h3>{{ loading ? 'Обновляем данные...' : 'Клиенты не найдены' }}</h3>
        <p *ngIf="!loading">Измените поисковый запрос или добавьте первого клиента.</p>
        <a class="action-button primary" routerLink="/dashboard/clients/new" *ngIf="!loading">Добавить первого клиента</a>
      </div>
    </ng-template>

    <footer class="pagination-bar">
      <span>Страница {{ filters.page }} из {{ totalPages }}</span>
      <label class="page-size-control">
        <span>Показывать</span>
        <select class="form-select" [ngModel]="filters.pageSize" (ngModelChange)="setPageSize($event)">
          <option *ngFor="let pageSize of pageSizeOptions" [ngValue]="pageSize">{{ pageSize }}</option>
        </select>
      </label>
      <div class="pagination-actions">
        <button class="action-button ghost" type="button" [disabled]="filters.page === 1" (click)="goToPage(filters.page - 1)">Назад</button>
        <button class="action-button ghost" type="button" [disabled]="filters.page === totalPages" (click)="goToPage(filters.page + 1)">Вперед</button>
      </div>
    </footer>
  </section>
</section>
